export default __webpack_public_path__ + "static/media/ico_call.b79ddb12.svg";